<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        version="1.1"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        width="512"
        height="512"
        x="0"
        y="0"
        viewBox="0 0 24 24"
        style="enable-background: new 0 0 512 512"
        xml:space="preserve"
        class="">
        <g>
            <path
                d="M17.854 17.146a.5.5 0 0 1-.708.707L12 12.707l-5.146 5.146a.498.498 0 0 1-.708 0 .5.5 0 0 1 0-.707L11.292 12 6.146 6.854a.5.5 0 0 1 .707-.707l5.146 5.146 5.146-5.146a.5.5 0 0 1 .707.707L12.706 12l5.146 5.146Z"
                fill="currentColor"
                opacity="1"
                data-original="currentColor"
                class=""></path>
        </g>
    </svg>
</template>
